import { requestStatusSchema } from '@ops-desk/contracts';
import { z } from 'zod';

/**
 * URL search params of the list page. Invalid values fall back to "unset" instead of erroring,
 * so a hand-edited or stale link still renders. `mine` stays unset until the user picks a
 * scope, which lets their saved preference decide. `new` makes the dialog linkable (and lets
 * the old `/submissions/new` URL redirect to it).
 *
 * The router JSON-parses each value, so `?quoteNumber=12345` arrives as a number: coerce it.
 */
export const submissionsSearchSchema = z.object({
  mine: z.boolean().optional().catch(undefined),
  status: requestStatusSchema.optional().catch(undefined),
  /** Opens the "New submission" dialog. */
  new: z.literal(true).optional().catch(undefined),
  quoteNumber: z
    .union([z.string(), z.number()])
    .transform((v) => String(v).trim())
    .pipe(z.string().min(1).max(40))
    .optional()
    .catch(undefined),
});
export type SubmissionsSearch = z.infer<typeof submissionsSearchSchema>;
